var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-header"},[_c('div',{staticClass:"header text-center"},[_c('h2',{staticClass:"title"},[_vm._v("Vector Map")]),_c('p',{staticClass:"category"},[_vm._v(" Looks great on any resolution. Made by our friends from "),_c('a',{attrs:{"target":"_blank","rel":"noopener","href":"http://datamaps.github.io"}},[_vm._v("Data Maps")]),_vm._v(". ")])])])
}]

export { render, staticRenderFns }